var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path3, _path4, _path5, _path6, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158.296,
    height: 143.82,
    viewBox: "0 0 158.296 143.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.627,
    y1: 0.5,
    x2: 1.473,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.017,
    x2: 0.983,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3282",
    "data-name": "Rectangle 3282",
    width: 12,
    height: 12,
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3282-3",
    "data-name": "Rectangle 3282",
    width: 8,
    height: 8,
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28678",
    "data-name": "Group 28678"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38041",
    "data-name": "Path 38041",
    d: "M144.619,40.723l.047.153a1.581,1.581,0,0,0,.053.153c2.561,7.884,19.572,9.786,38.156,4.228S214.63,28.77,212.445,20.774a1.162,1.162,0,0,0-.041-.153l-.047-.153c-4.769-15.939-23.8-24.324-42.5-18.736S139.856,24.783,144.619,40.723Z",
    transform: "translate(-58.446 0)",
    fill: "#fc3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38042",
    "data-name": "Path 38042",
    d: "M90.6,40.723l-.047.153a1.577,1.577,0,0,1-.053.153c-2.561,7.884-19.572,9.786-38.156,4.228S20.59,28.776,22.775,20.779a1.162,1.162,0,0,1,.041-.153l.047-.153c4.764-15.945,23.794-24.33,42.5-18.742S95.359,24.783,90.6,40.723Z",
    transform: "translate(-8.696 0)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 15.144,
    cy: 35.347,
    rx: 15.144,
    ry: 35.347,
    transform: "matrix(0.287, -0.958, 0.958, 0.287, 9.785, 35.137)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 35.347,
    cy: 15.144,
    rx: 35.347,
    ry: 15.144,
    transform: "matrix(0.958, -0.287, 0.287, 0.958, 81.888, 26.374)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3253",
    "data-name": "Rectangle 3253",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(21.591 52.222) rotate(-45)",
    fill: "#fc3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3254",
    "data-name": "Rectangle 3254",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(19.236 135.834) rotate(-45)",
    fill: "#c89b00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3255",
    "data-name": "Rectangle 3255",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(121.36 42.281) rotate(-27.97)",
    fill: "#c89b00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3256",
    "data-name": "Rectangle 3256",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(146.617 98.999) rotate(-30)",
    fill: "#fff369"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3257",
    "data-name": "Rectangle 3257",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(0 83.686) rotate(-30)",
    fill: "#fff369"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3258",
    "data-name": "Rectangle 3258",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(108.935 93.697) rotate(-30)",
    fill: "#fc3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3259",
    "data-name": "Rectangle 3259",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(103.633 136.681) rotate(-30)",
    fill: "#fc3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3260",
    "data-name": "Rectangle 3260",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(69.482 129.027) rotate(-30)",
    fill: "#fc3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3261",
    "data-name": "Rectangle 3261",
    width: 8.243,
    height: 8.243,
    rx: 2.64,
    transform: "translate(138.377 130.793) rotate(-30)",
    fill: "#fc3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38043",
    "data-name": "Path 38043",
    d: "M57.746,83.69s-15.309,13.543-21.2,32.974-4.122,39.451-4.122,39.451h5.3s2.944-26.5,8.243-40.629,16.3-28.852,16.3-28.852Z",
    transform: "translate(-12.66 -34.411)",
    fill: "#fc3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38044",
    "data-name": "Path 38044",
    d: "M81.516,76.456l1.766-1.766s21.2,2.355,18.253,19.431-18.253,15.9-11.188,20.02,8.243,6.477,7.655,11.776.524,11.017-9.456,12.571-20.626,5.682-13.537,13.926a95.766,95.766,0,0,0,15.468,14.132l-3.215,4.328s-19.879-8.45-20.173-18.46,3.827-15.309,16.193-18.253,15.9-4.122,7.655-9.421-14.161-13.366-6.489-20.815S105.069,85.289,81.516,76.456Z",
    transform: "translate(-27.009 -30.711)",
    fill: "#fff369"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38045",
    "data-name": "Path 38045",
    d: "M181.6,92.223l2.367-3.533s22.363,1.766,22.363,35.918S202.8,177.6,202.8,177.6l-4.4-.972s4.4-48.489.283-61.444S190.432,96.933,181.6,92.223Z",
    transform: "translate(-74.099 -36.467)",
    fill: "#fff369"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38046",
    "data-name": "Path 38046",
    d: "M143.776,110.69l3.533,1.178s-8.243,8.832-7.066,12.365,13.543,2.762,15.309,5.8-2.944,8.332-10.6,13.042-.589,5.235,10.6,5.558,11.188,8.573,7.655,15.05-8.385,8.243-8.385,8.243l-.495-1.766s11.229-12.094,7.7-15.763-14.95,1.048-21.9-5.435,15.486-13.543,10.746-14.132-16.617-2.567-16.858-11.882,9.763-12.259,9.763-12.259Z",
    transform: "translate(-54.528 -45.513)",
    fill: "#fc3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28772",
    "data-name": "Group 28772",
    transform: "translate(143.944 59.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102",
    "data-name": "Path 38102",
    d: "M8.023,4.386l3.545,1.037a.6.6,0,0,1,0,1.154L8.023,7.614a.6.6,0,0,0-.408.408L6.578,11.567a.6.6,0,0,1-1.154,0L4.387,8.022a.6.6,0,0,0-.408-.408L.433,6.577a.6.6,0,0,1,0-1.154L3.979,4.386a.6.6,0,0,0,.408-.408L5.424.432a.6.6,0,0,1,1.154,0L7.614,3.978a.6.6,0,0,0,.408.408",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28773",
    "data-name": "Group 28773",
    transform: "translate(37.679 84.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771-2",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102-2",
    "data-name": "Path 38102",
    d: "M8.023,4.386l3.545,1.037a.6.6,0,0,1,0,1.154L8.023,7.614a.6.6,0,0,0-.408.408L6.578,11.567a.6.6,0,0,1-1.154,0L4.387,8.022a.6.6,0,0,0-.408-.408L.433,6.577a.6.6,0,0,1,0-1.154L3.979,4.386a.6.6,0,0,0,.408-.408L5.424.432a.6.6,0,0,1,1.154,0L7.614,3.978a.6.6,0,0,0,.408.408",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28774",
    "data-name": "Group 28774",
    transform: "translate(5.261 55.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771-3",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102-3",
    "data-name": "Path 38102",
    d: "M5.349,2.924l2.364.691a.4.4,0,0,1,0,.769l-2.364.691a.4.4,0,0,0-.272.272L4.385,7.711a.4.4,0,0,1-.769,0L2.925,5.348a.4.4,0,0,0-.272-.272L.289,4.384a.4.4,0,0,1,0-.769l2.364-.691a.4.4,0,0,0,.272-.272L3.616.288a.4.4,0,0,1,.769,0l.691,2.364a.4.4,0,0,0,.272.272",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupWelcome);
export default __webpack_public_path__ + "static/media/signup-welcome.0d16fd9bcda4a7c16d1515bb3d4f375c.svg";
export { ForwardRef as ReactComponent };